const isDefined = util.isDefined;
const formatDate = util.formatDate;

class filterGroup {
  constructor(options) {
    this.name = options.name;
    this.filterConfigs = options.filterConfigs || [];
    this.filters = options.filters || [];
    this.exists = false;
    this.state = 'inactive';
  }

  createFilters() {
    this.filters = this.filterConfigs.map( filter => {
      let type = filter.type || 'select';
      let parentContainer = filter.parentContainer || '#primary-data-display-filters';
      let defaultValue = filter.defaultValue || "-1";

      if ( type.toLowerCase() === 'select' ) {
        let formEl = new Dropdown({
          name: filter.name,
          container: filter.container,
          parentContainer: parentContainer,
          elementExists: filter.elementExists,
          label: filter.label,
          classList: 'filter-select',
          data: filter.data,
          onChange: filter.onChange,
          selectedValue: filter.defaultValue
        }).buildDropdown().val(defaultValue);
        return formEl;
      } else if ( type.toLowerCase() === 'slider' ) {
        let formEl = new Slider({
          name: filter.name,
          container: filter.container,
          parentContainer: parentContainer,
          elementExists: filter.elementExists,
          valueField: filter.valueField,
          displayField: filter.displayField,
          label: filter.label,
          classList: 'filter-slider',
          data: filter.data,
          onChange: filter.onChange,
          selectedValue: filter.defaultValue
        }).buildSlider().val(defaultValue);
        return formEl;
      } else if ( type.toLowerCase() === 'checkbox-dropdown' ) {
        let formEl = new checkboxDropdown({
          name: filter.name,
          container: filter.container,
          parentContainer: parentContainer,
          elementExists: filter.elementExists,
          valueField: filter.valueField,
          displayField: filter.displayField,
          label: filter.label,
          classList: 'filter-checkbox-dropdown',
          data: filter.data,
          onChange: filter.onChange
        });

        if ( isDefined(filter.defaultValue) ) {
          // formEl.val(filter.defaultValue);
        } else {
          // formEl.val("-1");
        }
        return formEl;
      } else if ( type.toLowerCase() === 'radio-list' ) {
        let formEl = new radioList({
          name: filter.name,
          container: filter.container,
          parentContainer: parentContainer,
          elementExists: filter.elementExists,
          displayInline: filter.displayInline,
          valueField: filter.valueField,
          displayField: filter.displayField,
          classList: 'filter-radio-list',
          data: filter.data,
          onChange: filter.onChange
        }).buildList();

        if ( isDefined(filter.defaultValue) ) {
          // formEl.val(filter.defaultValue);
        } else {
          // formEl.val("-1");
        }
        return formEl;
      } else if ( type.toLowerCase() === 'date' ) {
        let formEl = new datePicker({
          name: filter.name,
          container: filter.container,
          parentContainer: parentContainer,
          elementExists: filter.elementExists,
          label: filter.label,
          classList: 'filter-date-picker',
          onChange: filter.onChange
        });

        if ( isDefined(filter.defaultValue) ) {
          if ( isNaN(parseInt(filter.defaultValue)) ) {
            let formattedDate = formatDate(filter.defaultValue, 'yyyy-mm-dd');
            formEl.setDate(formattedDate);
          } else {
            formEl.setDate(filter.defaultValue);
          }
        }
        return formEl;
      }
    })
    this.exists = true;
    this.state = 'active';
    return this;
  } // createFilters()

  hide() {
    this.state = 'inactive';
    if ( this.exists ) {
      this.filters.forEach( v => {
        v.container.closest('.mercury-form-group').style.display = 'none';
      });
    }
    return this;
  } // hide

  show() {
    this.state = 'active';
    if ( this.exists ) {
      this.filters.forEach( v => {
        v.container.closest('.mercury-form-group').style.display = 'inline-block';
      });
    }
    return this;
  } // hide

} // class filterGroup
